import { PureComponent } from 'react';

import ProductPrice from 'Component/ProductPrice';

import Image from 'Component/Image';
import Field from 'Component/Field';
import Link from 'Component/Link';
import Loader from 'Component/Loader';

import { formatCurrency, roundPrice } from 'Util/Price';

import './BuyTogether.style';

export class BuyTogether extends PureComponent {
    renderTitle() {
        return (
            <h3 block="BuyTogether" elem="Title">{ __('Frequently bought together') }</h3>
        )
    }

    renderContent() {
        const { isLoading } = this.props;

        return (
            <div block="BuyTogether" elem="Content">
                <Loader isLoading={ isLoading } />
                { this.renderItems() }
                { this.renderTotals() }
            </div>
        )
    }

    renderItems() {
        const { items } = this.props;

        return (
            <div block="BuyTogether" elem="Products">
                <div block="BuyTogether" elem="Images">
                    { items.map(this.renderItemImage) }
                </div>
                <div block="BuyTogether" elem="Items">
                    { items.map(this.renderItemText) }
                </div>
            </div>
        )
    }

    renderItemImage = ({ id, name, small_image, url }) => {
        return (
            <Link key={ id } to={ url } block="BuyTogether" elem="Image">
                <Image
                    src={ small_image.url }
                    alt={ name }
                    ratio="custom"
                    mix={ { block: 'ProductCard', elem: 'Picture' } }
                    isPlaceholder={ !id }
                />
            </Link>
        )
    }

    renderItemText = ({ id, sku, name, price_range, url }) => {
        const { products, onItemClick } = this.props;

        return (
            <div key={ id } block="BuyTogether" elem="Item">
                <Field
                  key={ sku }
                  name={ sku }
                  id={ sku }
                  value={ sku }
                  type="checkbox"
                  label=" "
                  onClick={ (e) => onItemClick(sku) }
                  checked={ products.find(item => item.sku === sku) }
                />
                <p block="BuyTogether" elem="ItemName" onClick={ (e) => onItemClick(sku) }>{ name }</p>
                <div onClick={ (e) => onItemClick(sku) }>
                    <ProductPrice
                      price={ price_range }
                      mix={ { block: 'BuyTogether', elem: 'ItemPrice' } }
                    />
                </div>
            </div>
        )
    }

    renderTotals() {
        const { products, default_display_currency_code, onButtonClick } = this.props;

        return (
            <div block="BuyTogether" elem="Totals">
                <button onClick={ () => onButtonClick() }>{ `${ __('Add all products to cart') }: ${ roundPrice(products.reduce( (acc, item) => acc + item.price, 0 )) } ${ formatCurrency(default_display_currency_code) }` }</button>
            </div>
        )
    }

    render() {
        const { items } = this.props;

        if (!items.length) {
            return null;
        }

        return (
            <div block="BuyTogether">
                <div block="BuyTogether" elem="Wrapper">
                    { this.renderTitle() }
                    { this.renderContent() }
                </div>
            </div>
        )
    }
}

export default BuyTogether;
